module.exports = __webpack_public_path__ + "static/media/parts_26.84ec4c00.svg";